import { render, staticRenderFns } from "./tcgm.vue?vue&type=template&id=6cb67588&scoped=true&"
import script from "./tcgm.vue?vue&type=script&lang=js&"
export * from "./tcgm.vue?vue&type=script&lang=js&"
import style0 from "./tcgm.vue?vue&type=style&index=0&id=6cb67588&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb67588",
  null
  
)

export default component.exports